import React, { memo } from 'react';

import BoughtTicketItem from '../BoughtTicketItem/BoughtTicketItem';
import { compareTicketsByPurchasedTime } from '../../utils';
import styles from './style.module.css';
import { OrderTicketList } from 'types';

type BoughtTicketListProps = {
    ticketList?: OrderTicketList[];
};

/**
 * 購入済みのチケットリスト
 */
const BoughtTicketList = memo(({ ticketList = [] }: BoughtTicketListProps) => {
    return (
        <div className={styles.container}>
            {ticketList.sort(compareTicketsByPurchasedTime).map((ticket, index) => (
                <BoughtTicketItem key={index} to={'/bought/detail'} ticket={ticket} />
            ))}
        </div>
    );
});
export default BoughtTicketList;
